import axiosInstance from './axiosInstance'
import { ApiResponse, WalletTransaction, PagedResponse } from '../types'

export const walletApi = {
  getBalance: () =>
    axiosInstance.get<ApiResponse<{ balancePaise: number }>>('/wallet/balance'),

  createRazorpayOrder: (amountPaise: number) =>
    axiosInstance.post<ApiResponse<{
      razorpayOrderId: string
      razorpayKeyId: string
      amount: number
      currency: string
    }>>('/wallet/add-funds/razorpay', { amountPaise }),

  verifyRazorpayPayment: (payload: {
    razorpay_order_id: string
    razorpay_payment_id: string
    razorpay_signature: string
  }) => axiosInstance.post<ApiResponse<void>>('/wallet/webhook/razorpay', payload),

  addFundsPaytm: (amountPaise: number) =>
    axiosInstance.post<ApiResponse<{ mid: string; orderId: string; amount: string; checksum: string; paytmHost: string }>>(
      '/wallet/add-funds/paytm', { amountPaise }
    ),

  addFundsUpi: (amountPaise: number) =>
    axiosInstance.post<ApiResponse<{ orderId: string; amount: string; currency: string }>>(
      '/wallet/add-funds/upi', { amountPaise }
    ),

  withdraw: (amountPaise: number) =>
    axiosInstance.post<ApiResponse<void>>('/wallet/withdraw', { amountPaise }),

  getTransactions: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<WalletTransaction>>>(
      `/wallet/transactions?page=${page}&size=${size}`
    ),
}
